import React from 'react';
import PropTypes from 'prop-types';
import OptionMessage from './OptionMessage';
import { Message } from '@aperza/ui';
export default class SearchResultHeader extends React.Component {
    constructor(props) {
        super(props);
        this.changeLimitForRecords = (e) => {
            this.props.updateLimit(e.target.value);
        };
    }
    render() {
        let pageMetadata = this.props.pageMetadata;
        return (React.createElement("div", { className: "rt-top" },
            React.createElement("span", { className: "headerCount" },
                React.createElement(Message, { messageId: 'searchResultHeader.label', values: {
                        total: pageMetadata.totalRecords,
                        from: pageMetadata.recordsFrom,
                        to: pageMetadata.recordsTo,
                    } })),
            React.createElement("span", { className: "headerPageSizeDd" },
                React.createElement("select", { onChange: this.changeLimitForRecords },
                    React.createElement(OptionMessage, { optionValue: 10, messageId: 'searchResultHeader.limit', values: { limit: 10 } }),
                    React.createElement(OptionMessage, { optionValue: 20, messageId: 'searchResultHeader.limit', values: { limit: 20 } }),
                    React.createElement(OptionMessage, { optionValue: 30, messageId: 'searchResultHeader.limit', values: { limit: 30 } })))));
    }
}
SearchResultHeader.propTypes = {
    pageMetadata: PropTypes.object.isRequired,
};
